import {Viewer} from "./viewer";
import React, {useEffect, useRef, useState} from "react";
import {PdfDialogState} from "./state";
import {useStyles} from "./styles"
import ResizablePdfDialog from "../dialog/index.jsx"
import {ViewerApi} from "./viewer/api";
import {PDFDialogProps} from "./props";
import {Footer} from "./footer";
import {debounce} from "lodash";
import {PdfSearch} from "./search";
import {usePaging} from "./footer/usePaging";
import {Header} from "./header";

export const PDFDialog = (props: PDFDialogProps) => {
    const {
        isOpen,
        onClose,
        isHidden,
        isAnswerLocked,
        onClickInside,
        onToggleCollapse,
        onToggleExpand,
        isExpanded,
        updateDialogRect,
        zIndex,
        dialogRect,
    } = props

    const [state, setState] = useState(new PdfDialogState())
    const viewerApiRef = useRef<ViewerApi>()
    const styles = useStyles()

    const debouncedFit = debounce(() => viewerApiRef.current?.fitWidth(), 300)

    const { updatePageNumber, setNumPages } = usePaging(state, setState, viewerApiRef)

    const setMatchesCount = (matchesCount) => setState((prev) => ({...prev, matchesCount}))

    return (
        <ResizablePdfDialog
            active={isOpen}
            hideFooter={true}
            aboveHeaderContent={<><PdfSearch {...{viewerApiRef, isAnswerLocked, matchesCount: state.matchesCount}} /><Header {...{isExpanded, onToggleExpand, onToggleCollapse}} /></>}
            footerContent={<Footer {...{state, setState, viewerApiRef}}/>}
            containerClassName={styles.container}
            className={styles.dialog}
            isHidden={isHidden}
            onRequestClose={onClose}
            dialogRight={60}
            dialogTop={160}
            hasOuterScrollX={true}
            onResize={() => {
                onToggleExpand(false)
                debouncedFit()
            }}
            onToggle={(isExpanded) => {
                onToggleExpand(isExpanded)
                viewerApiRef.current?.fitWidth()
            }}
            hasPerfectScrollbar={false}
            isExpanded={isExpanded}
            onClickInside={onClickInside}
            dialogRect={dialogRect}
            updateDialogRect={updateDialogRect}
            zIndex={zIndex}>
            <div className={styles.pdfContainer}>
                <Viewer src={props.src}
                        apiRef={viewerApiRef}
                        onChangePage={updatePageNumber}
                        onSetNumPages={setNumPages}
                        onMatchesCount={setMatchesCount} />
            </div>
        </ResizablePdfDialog>
    )
}
